/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ChatRegularReport from './chat-regular-report-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ChatRegularReport {...validProps} />;
}

SvgComponent.iconName = 'chatRegularReport';

export const ChatRegularReportIcon = svgIconWrapper(SvgComponent);
